import React from 'react';
import showdown from 'showdown';
import DOMPurify from 'dompurify';

const MarkdownToHtml = ({ markdownText }) => {

  // Create a new instance of showdown
  const converter = new showdown.Converter();
  
  // Convert Markdown to HTML
  const htmlText = converter.makeHtml(markdownText);

  // Sanitize the HTML to prevent XSS attacks
  const sanitizedHtml = DOMPurify.sanitize(htmlText);

  // Render the HTML
  return <div style={{overflowWrap: "anywhere"}} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

export default MarkdownToHtml;
